import * as React from "react";

import {BufferForm}     from "@Common/logic/checkout/common/buffer-form";
import {cs}             from "@Common/react/chain-services";
import {getNestedValue} from "@Common/utils/arr-path";
import {cascadeSum}     from "@Common/utils/cascade";

import {Line}           from "./line";
import {sumCreditItems} from "./sum-credit-items";

export const ApplyCreditLine = ({label, cartAttr, itemAttr, applyChange, store}) => cs(
    ["rawSelected", (_, next) => next(getNestedValue(store.cart, ["appliedCredits", cartAttr, "length"]))],
    ["selected", ({rawSelected}, next) => BufferForm({
        value: rawSelected,
        disableBuffer: !store.saving,
        applyChange,
        next,
    })],
    ({selected, rawSelected}) => (
        Line({
            selected,
            label,
            avaiAmount: sumCreditItems(store.cart.items, {itemAttr}),
            appliedAmount: rawSelected && cascadeSum(store.cart, `appliedCredits.${cartAttr}[*].amount`),
        })
    )
);


